import type { IStripeSdk, StripeMode } from "./types";
import { StripeSdkLocal } from "./local";
import { StripeSdkReal } from "./real";

export interface StripeSdkSettings {
  mode: StripeMode;
  // baseUrl is required in local mode (points at stripe-sim). Ignored in prod.
  baseUrl?: string;
  // publishableKey is required in prod mode (handed to @stripe/stripe-js's
  // loadStripe). Ignored in local mode.
  publishableKey?: string;
}

export class StripeSdkFactory {
  static createInstance(settings: StripeSdkSettings): IStripeSdk {
    if (settings.mode === "local") {
      if (!settings.baseUrl) {
        throw new Error("Cannot create Stripe SDK in local mode without baseUrl");
      }
      return new StripeSdkLocal(settings.baseUrl);
    }
    if (!settings.publishableKey) {
      throw new Error("Cannot create Stripe SDK in prod mode without publishableKey");
    }
    return new StripeSdkReal(settings.publishableKey);
  }
}
